import cx from 'classnames'

export const COLOR_MAP = {
  pink: {
    bg: cx(
      'bg-pink-500',
      'ring-[color-mix(in_oklab,var(--color-pink-500)_15%,var(--color-amaze-paper))] inset-ring-pink-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-pink-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-pink-400/50',
    ),
    bgTransparent: cx('bg-pink-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-pink-500),transparent)]',
    ),
  },
  fuchsia: {
    bg: cx(
      'bg-fuchsia-500',
      'ring-[color-mix(in_oklab,var(--color-fuchsia-500)_15%,var(--color-amaze-paper))] inset-ring-fuchsia-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-fuchsia-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-fuchsia-400/50',
    ),
    bgTransparent: cx('bg-fuchsia-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-fuchsia-500),transparent)]',
    ),
  },
  zinc: {
    bg: cx(
      'bg-zinc-500',
      'ring-[color-mix(in_oklab,var(--color-zinc-500)_15%,var(--color-amaze-paper))] inset-ring-zinc-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-zinc-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-zinc-400/50',
    ),
    bgTransparent: cx('bg-zinc-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-zinc-500),transparent)]',
    ),
  },
  stone: {
    bg: cx(
      'bg-stone-500',
      'ring-[color-mix(in_oklab,var(--color-stone-500)_15%,var(--color-amaze-paper))] inset-ring-stone-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-stone-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-stone-400/50',
    ),
    bgTransparent: cx('bg-stone-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-stone-500),transparent)]',
    ),
  },
  violet: {
    bg: cx(
      'bg-violet-500',
      'ring-[color-mix(in_oklab,var(--color-violet-500)_15%,var(--color-amaze-paper))] inset-ring-violet-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-violet-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-violet-400/50',
    ),
    bgTransparent: cx('bg-violet-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-violet-500),transparent)]',
    ),
  },
  teal: {
    bg: cx(
      'bg-teal-500',
      'ring-[color-mix(in_oklab,var(--color-teal-500)_15%,var(--color-amaze-paper))] inset-ring-teal-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-teal-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-teal-400/50',
    ),
    bgTransparent: cx('bg-teal-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-teal-500),transparent)]',
    ),
  },
  cyan: {
    bg: cx(
      'bg-cyan-500',
      'ring-[color-mix(in_oklab,var(--color-cyan-500)_15%,var(--color-amaze-paper))] inset-ring-cyan-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-cyan-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-cyan-400/50',
    ),
    bgTransparent: cx('bg-cyan-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-cyan-500),transparent)]',
    ),
  },
  darkBlue: {
    bg: cx(
      'bg-blue-800',
      'ring-[color-mix(in_oklab,var(--color-blue-800)_15%,var(--color-amaze-paper))] inset-ring-blue-900/50',
      'dark:ring-[color-mix(in_oklab,var(--color-blue-800)_15%,var(--color-amaze-paperDark))] dark:inset-ring-blue-700/50',
    ),
    bgTransparent: cx('bg-blue-800/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-blue-800),transparent)]',
    ),
  },
  blue: {
    bg: cx(
      'bg-blue-500',
      'ring-[color-mix(in_oklab,var(--color-blue-500)_15%,var(--color-amaze-paper))] inset-ring-blue-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-blue-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-blue-400/50',
    ),
    bgTransparent: cx('bg-blue-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-blue-500),transparent)]',
    ),
  },
  emerald: {
    bg: cx(
      'bg-emerald-500',
      'ring-[color-mix(in_oklab,var(--color-emerald-500)_15%,var(--color-amaze-paper))] inset-ring-emerald-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-emerald-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-emerald-400/50',
    ),
    bgTransparent: cx('bg-emerald-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-emerald-500),transparent)]',
    ),
  },
  red: {
    bg: cx(
      'bg-red-500',
      'ring-[color-mix(in_oklab,var(--color-red-500)_15%,var(--color-amaze-paper))] inset-ring-red-700/50',
      'dark:ring-[color-mix(in_oklab,var(--color-red-500)_15%,var(--color-amaze-paperDark))] dark:inset-ring-red-400/50',
    ),
    bgTransparent: cx('bg-red-500/50'),
    shadow: cx(
      'shadow-[0px_0px_4px_2px_color-mix(in_oklab,var(--color-red-500),transparent)]',
    ),
  },
}
